<template>
  <div id="app" :class="appVersion">
  	  <div v-bar="{preventParentScroll: true}" class="el1full">
  	  	<router-view></router-view>
  	  </div>
  </div>
</template>

<script>
export default {
  	name: 'App',
  	data: function () {
	    return {
	    	appVersion: '',
	    }
   	},
   	created: function () {
        this.appVersion = this.$store.getters.getAppVersion;
    }
}
</script>




// WEBPACK FOOTER //
// src/App.vue